import { ProFormSelect } from "@ant-design/pro-components";
import { DatePicker, Divider, Form, Input, InputNumber, Radio, Space, Spin, TreeSelect } from "antd";
import { useWatch } from 'antd/es/form/Form';
import CustomSelect from "base/ui/components/CustomSelect";
import dayjs from "dayjs";
import useDebounce from 'hooks/useDebounce';
import { cloneDeep, uniq } from 'lodash';
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from 'react-router-dom';
import { CommonModel } from "services/Main/common_services";
import { CriterialListModel } from 'services/Main/criterial_services';
import { CustomerSegmentModel, commonLazySegment } from 'services/Main/customerSegment_services';
import {
  commonPresenter,
  commonStore,
  criterialPresenter,
  criterialStore,
} from "stores/root_store";
import { debounce } from "utils/debounce";
import { SearchForm, SearchItem } from "./SearchBox";
import { getPlantCode } from 'utils/localStorageHelper';

export const dropdownTrueFalse2 = [
  {
    key: null,
    value: "--Tất cả--",
  },
  {
    key: true,
    value: "Có",
  },
  {
    key: false,
    value: "Không",
  },
];

const { RangePicker } = DatePicker;

export type DetailCriterialIds = {
  criteriaCode: string;
  values?: {
    criteriaValue: any,
    dataType: string | null,
    sortType?: string
  }[];
  inputType: "single" | "fromTo",



};

type CriterialProps = {
  onCriterialChange?: (data: DetailCriterialIds[]) => void;

  dataDetail?: CustomerSegmentModel;
  quickSearch: commonLazySegment[];

  isValidated?: boolean;
  validation?: (value: boolean) => void,
  loadingSegment: boolean

};

function Criterial(props: CriterialProps) {
  const { onCriterialChange, quickSearch, isValidated, validation } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  // const [formFilter] = Form.useForm();

  const [searchParams] = useSearchParams();
  // lấy id của tab (nếu như có id là tab xem chi tiết)
  const tabIdParam = searchParams.get('tabId');
  const [fistRender, setFistRender] = useState(false)
  const tabId = tabIdParam?.includes('DETAIL') ? true : false
  const tabIdIsCreate = tabIdParam?.includes('CREATE') ? true : false

  console.log({ aaaA: props.dataDetail });


  const dropdownTrueFalse = [
    {
      key: "yes",
      value: t("search-form.yes"),
    },
    {
      key: "no",
      value: t("search-form.no"),
    },
  ];

  const status = [
    {
      key: "true",
      value: t("search-form.active"),
    },
    {
      key: "false",
      value: t("search-form.inactive"),
    },
  ];

  //========================================================================================================== //
  //-------------------------------------------TIÊU CHÍ-------------------------------------------------//
  //========================================================================================================== //

  // DROPDOWN TIÊU CHÍ
  const [criteriaDropdown, setCriteriaDropdown] = useState<CriterialListModel[]>()
  // Tỉnh/ Thành phố
  const [listProvince, setListProvince] = useState<CommonModel[]>([]);
  // Quận / huyện
  const [listDistrict, setListDistrict] = useState<CommonModel[]>([]);
  // Phường xã
  const [listWard, setListWard] = useState<CommonModel[]>([]);
  // Khu vực
  const [listSaleOffice, setListSaleOffice] = useState<CommonModel[]>([]);
  // Châu lục
  const [continents, setContinents] = useState<CommonModel[]>([])
  // Quốc gia
  const [countries, setCountries] = useState<CommonModel[]>([])
  const [allCountries, setAllCountries] = useState<CommonModel[]>([])
  // Công ty
  const [listCompany, setListCompany] = useState<CommonModel[]>([]);
  const [listCompanySaleOrg, setListCompanySaleOrg] = useState<CommonModel[]>([]);
  // Thị trường của khách hàng
  const [customerMarket, setCustomerMarket] = useState<CommonModel[]>([])
  // Chi nhánhh
  const [listStore, setListStore] = useState<CommonModel[]>([]);
  // Nhóm khách hàng
  const [listCustomerGroup, setListCustomerGroup] = useState<CommonModel[]>([]);
  // Ngành nghề
  const [listCustomerCareer, setListCustomerCareer] = useState<CommonModel[]>(
    []
  );
  // Ngành nghề bán lẻ
  const [listCustomerCareerRetail, setListCustomerCareerRetail] = useState<CommonModel[]>(
    []
  );
  // Diện tích showroom
  const [showroomArea, setShowroomArea] = useState<CommonModel[]>();
  const [listMarketShare, setListMarketShare] = useState<CommonModel[]>();
  // nhân viên
  const [numberOfEmployees, setNumberOfEmployees] = useState<CommonModel[]>();
  // thiết kệ
  const [numberOfDesigner, setNumberOfDesigner] = useState<CommonModel[]>();
  // Hệ thống kho bãi NPP/DL
  const [warehouseSystem, setWareHouseSystem] = useState<CommonModel[]>([])
  // nhóm sả phẩm chủ lực
  const [keyProductGroup, setKeyProductGroup] = useState<CommonModel[]>();
  // thời hạn trung bình quá hạn
  const [timeAverage, setTimeAverage] = useState<CommonModel[]>();
  // const [timePayment, setTimePayment] = useState<CommonModel[]>();
  // NV kinh doanh
  const [listSalesEmployee, setListSalesEmployee] = useState<CommonModel[]>([]);
  // NV Admin
  const [listAdminEmployee, setListAdminEmployee] = useState<CommonModel[]>([]);
  // Người tạo
  const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
  // Phòng ban
  const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);
  // phân Loại KH
  const [listCustomerType, setListCustomerType] = useState<CommonModel[]>([]);
  // Nguồn KH
  const [listCustomerSource, setListCustomerSource] = useState<CommonModel[]>(
    []
  );
  // Chủ đầu tư
  const [listInvestor, setListInvestor] = useState<CommonModel[]>(
    []
  );
  // nhóm hàng mua nhiều
  const [listOrderSeller, setListOrderSeller] = useState<CommonModel[]>(
    []
  );


  // Loại KH ghé thăm
  const [listTypeVisitCustomer, setListTypeVisitCustomer] = useState<CommonModel[]>([]);
  // Thị hiếu
  const [listTrend, setListTrend] = useState<CommonModel[]>([]);
  // Nhu cầu làm nội thất
  const [listHouseType, setListHouseType] = useState<CommonModel[]>([]);
  // Hình thức
  const [listShapeType, setListShapeType] = useState<CommonModel[]>([]);
  // Chỉ định dùng vật liệu AC
  const [listIndicationUser, setListIndicationsUser] = useState<CommonModel[]>([]);

  // Phân nhóm KH
  const [listCustomerAccountGroup, setListCustomerAccountGroup] = useState<
    CommonModel[]
  >([]);
  // Phân hạng kh
  const [listCustomerRank, setListCustomerRank] = useState<CommonModel[]>([]);
  // data common date
  const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);

  //   -----------------------------------------------------------------------------------------------------

  const [disabledCreateDate, setDisabledCreateDate] = useState(false);
  // list filter
  const [listFilter, setListFilter] = useState<string[]>([]);
  const [listParrentTitle, setListParrentTitle] = useState<any[]>([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // data dropdown tiêu chí
  const [dropdownFilter, setDropdownFilter] = useState<CommonModel[]>([]);

  //=======================XXX========================XXX=========================XXX========================= //

  //========================================================================================================== //
  //-------------------------------------------LẤY DATA COMMON-------------------------------------------------//
  //========================================================================================================== //
  //-----VỊ TRÍ ĐỊA LÍ-------------------------------------------------------------------------------------------- //
  const thiTruong = useWatch('TC20.5', form)

  // Tỉnh/ Thành phố
  const getDataProvince = async (area?: string) => {
    await commonPresenter.getListProvince(commonStore, area);
    if (commonStore.commonRespone.isSuccess) {
      setListProvince(commonStore.commonRespone.data);
    }
  };
  // call data thanh pho
  const khuVuc = useWatch('TC23', form)
  useEffect(() => {
    khuVuc && getDataProvince(khuVuc)
  }, [khuVuc])

  // Quận / huyện
  const getDataDistrict = async (province?: string[]) => {
    if (province && Array.isArray(province)) {
      await commonPresenter.getListDistrict(commonStore, province);
      if (commonStore.commonRespone.isSuccess) {
        setListDistrict(commonStore.commonRespone.data);
      }
    } else {
      setListDistrict([]);
    }
  };
  // call data quan huyen
  const tinhThanh = useWatch('TC24', form)
  useEffect(() => {
    tinhThanh && getDataDistrict(Array.isArray(tinhThanh) ? tinhThanh : [tinhThanh])
  }, [tinhThanh])


  // Phường xã
  const getDataWard = async (district?: string[]) => {
    if (district) {
      await commonPresenter.getListWard(commonStore, district);
      if (commonStore.commonRespone.isSuccess) {
        setListWard(commonStore.commonRespone.data);
      }
    } else {
      setListWard([]);
    }
  };
  // call data tinh thanh quan huyen khi chinh sua
  const quanHuyen = useWatch('TC25', form)
  useEffect(() => {
    quanHuyen && getDataWard(Array.isArray(quanHuyen) ? quanHuyen : [quanHuyen])
  }, [quanHuyen])
  // Khu vực =================================================================================================
  const valuesNation = useWatch('TC22', form)
  const getDataSaleOffice = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "SaleOffice");
    if (commonStore.commonRespone.isSuccess) {
      if (valuesNation === 'VN') {
        setListSaleOffice(commonStore.commonRespone.data);
      } else {
        setListSaleOffice([])
      }
    }
  };

  // value của TC21 Châu Lục ==================================================================
  // Quốc gia
  const getDataContries = async (continent?: string) => {
    await commonPresenter.getCommonDataByKey(commonStore, "Nation", continent);
    if (commonStore.commonRespone.isSuccess) {
      setCountries(commonStore.commonRespone.data);

      // set initial value cho quốc gia là việt nam
      if (!tabId) {
        form.setFieldValue('TC22', 'VN')
      }
    }
  };
  // All Quốc gia
  const getAllDataContries = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Nation", '2100,2101,2102,2103,2104');
    if (commonStore.commonRespone.isSuccess) {
      setAllCountries(commonStore.commonRespone.data);
    }
  };
  // Châu lục
  const getDataContinents = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Continents");
    if (commonStore.commonRespone.isSuccess) {
      setContinents(commonStore.commonRespone.data);

      // set initial value cho châu lục là CHÂU Á
      if (!tabId) {
        form.setFieldValue('TC21', '2101')
      }
    }
  };
  //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
  //-----TÀI CHÍNH KHÁCH HÀNG-------------------------------------------------------------------------------------------- //
  // Phân khúc đầu tư
  const getDropdownByKey = async (key: string) => {
    await commonPresenter.getCommonDataByKey(commonStore, key);
    if (commonStore.commonRespone.isSuccess) {
      return commonStore.commonRespone.data.map((item) => ({
        label: item.value,
        value: item.key as string
      }));
    }
    return []
  }
  //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
  // Công ty theo tài khoản
  const getDataCompany = async () => {
    await commonPresenter.getCompanyByAccount(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCompany(commonStore.commonRespone.data);
    }
  };
  // Công ty
  const getDataCompanySaleOrg = async () => {
    await commonPresenter.getListSaleOrg(commonStore, 'SEGMENT');
    if (commonStore.commonRespone.isSuccess) {
      setListCompanySaleOrg(commonStore.commonRespone.data);
    }
  };
  // Thị trường của khách hàng
  const getDataCustomerMarket = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerMarket");
    if (commonStore.commonRespone.isSuccess) {
      setCustomerMarket(commonStore.commonRespone.data);
    }
  };
  // Chi nhánhh
  const getDataStore = async () => {
    await commonPresenter.getStoreByAccount(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListStore(commonStore.commonRespone.data);
    }
  };
  // Nhóm khách hàng
  const getDataCustomerGroup = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerGroup");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerGroup(commonStore.commonRespone.data);
    }
  };
  // Ngành nghề
  const getDataCustomerCareer = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerCareer");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerCareer(commonStore.commonRespone.data);
    }
  };
  // Ngành nghề bán lẻ
  const getDataCustomerCareerRetail = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerCareerRetail");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerCareerRetail(commonStore.commonRespone.data);
    }
  };

  // danh sách diện tích
  const getDataShowroomArea = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Area");
    if (commonStore.commonRespone.isSuccess) {
      setShowroomArea(commonStore.commonRespone.data);
    }
  }
  // danh sách Thị phần
  const getDataMarketShare = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Marketshare");
    if (commonStore.commonRespone.isSuccess) {
      setListMarketShare(commonStore.commonRespone.data);
    }
  }
  // danh sách số lượng nhân viên
  const getDataNumberOfEmployee = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "NumberOfEmployees");
    if (commonStore.commonRespone.isSuccess) {
      setNumberOfEmployees(commonStore.commonRespone.data);
    }
  }
  // danh sách số lượng thiết kế
  const getDataNumberOfDesigner = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "NumberOfDesigners");
    if (commonStore.commonRespone.isSuccess) {
      setNumberOfDesigner(commonStore.commonRespone.data);
    }
  }
  // danh sách nhóm sản phẩm chủ lực
  const getDataKeyProductGroups = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "KeyProductGroups");
    if (commonStore.commonRespone.isSuccess) {
      setKeyProductGroup(commonStore.commonRespone.data);
    }
  }
  // Thời hạn trung bình quá hạn
  const getDataTimeAverage = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "THANHTOANQUAHAN");
    if (commonStore.commonRespone.isSuccess) {
      setTimeAverage(commonStore.commonRespone.data);
    }
  }
  // Thời hạn thanh toán
  // const getDataTimePayment = async () => {
  //   await commonPresenter.getCommonDataByKey(commonStore, "PaymentTerm");
  //   if (commonStore.commonRespone.isSuccess) {
  //     setTimePayment(commonStore.commonRespone.data);
  //   }
  // }
  // danh sách nhóm sản phẩm chủ lực
  const getDataWarehouseSystem = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "WarehouseSystem");
    if (commonStore.commonRespone.isSuccess) {
      setWareHouseSystem(commonStore.commonRespone.data);
    }
  }


  // NV kinh doanh / nhân viên admin / người tạo
  // type :
  //  +  NV kinh doanh : NVKD
  //  +  NV admin : NVAD
  //  +  Người tạo : CREATE
  const getDataSalesEmployee = async (
    type: "NVKD" | "NVAD" | "CREATE",
    key?: string
  ) => {
    await commonPresenter.getListPersonInCharge(commonStore, key);
    if (commonStore.commonRespone.isSuccess) {
      switch (type) {
        case "NVKD":
          setListSalesEmployee(commonStore.commonRespone.data);
          break;
        case "NVAD":
          setListAdminEmployee(commonStore.commonRespone.data);
          break;
        case "CREATE":
          setListCreateBy(commonStore.commonRespone.data);
          break;
      }
    }
  };
  const searchSalesEmployee = debounce(getDataSalesEmployee, 300);
  // -------------------------------------------------------------------------------------------------  ----------------------------------------------------------------
  // Phòng ban
  const getDataDepartment = async (key?: string) => {
    await commonPresenter.getListDepartment(commonStore, key);
    if (commonStore.commonRespone.isSuccess) {
      setListDepartment(commonStore.commonRespone.data);
    }
  };

  // phân Loại KH
  const valuesCustomerType = useWatch('TC01.2', form)
  const getDataCustomerType = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerType");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerType(commonStore.commonRespone.data);
    }
  };
  // Nguồn KH
  const getDataCustomerSource = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerSource");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerSource(commonStore.commonRespone.data);
    }
  };
  // Phân nhóm KH
  const getDataCustomerAccountGroup = async () => {
    await commonPresenter.getCommonDataByKey(
      commonStore,
      "CustomerAccountGroup"
    );
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerAccountGroup(commonStore.commonRespone.data);
    }
  };
  // Phân hạng kh
  const getDataCustomerRank = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Customer_Class");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerRank(commonStore.commonRespone.data);
    }
  };
  // Loại KH ghé thăm
  const getDataTypeCustomer = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerClass");
    if (commonStore.commonRespone.isSuccess) {
      setListTypeVisitCustomer(commonStore.commonRespone.data);
    }
  };
  // Sản phẩm Thị hiếu
  const getDataTrend = async (key = '') => {
    await commonPresenter.getListSPTH(commonStore, key ? key : undefined);
    if (commonStore.commonRespone.isSuccess) {
      setListTrend(commonStore.commonRespone.data);
    }
  };
  const debounceSearchSPTH = useDebounce(getDataTrend, 300);

  // Nhu cầu làm nội thất
  const getDataHouseType = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "HouseType");
    if (commonStore.commonRespone.isSuccess) {
      setListHouseType(commonStore.commonRespone.data);
    }
  };
  // Hình thức
  const getDataShapeType = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "ShapeType");
    if (commonStore.commonRespone.isSuccess) {
      setListShapeType(commonStore.commonRespone.data);
    }
  };
  // Chỉ định dùng vật liệu AC
  const getDataIndicationsUserMaterial = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "IndicationsUseACMaterial");
    if (commonStore.commonRespone.isSuccess) {
      setListIndicationsUser(commonStore.commonRespone.data);
    }
  };
  // Lấy danh sách common date
  const getListCommonDate = async () => {
    await commonPresenter.getListSelectCommonDate(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCommonDate(commonStore.commonRespone.data);
    }
  };
  // Lấy ngày bằng common data
  const getDateByKey = async (key: string) => {
    await commonPresenter.getDateByCommonDate(commonStore, key);
    if (commonStore.commonDate.fromDate) {
      form.setFieldValue(
        "CreateFromDate",
        dayjs(commonStore.commonDate.fromDate)
      );
      form.setFieldValue("CreateToDate", dayjs(commonStore.commonDate.toDate));
    } else {
      form.setFieldValue("CreateFromDate", undefined);
      form.setFieldValue("CreateToDate", undefined);
    }
    handleFormValuesChange();
  };

  // DROPDOWN TREESELECT DANH SÁCH TIÊU CHÍ
  const getDropdownCriteria = async () => {
    await criterialPresenter.getDataCriterial2(criterialStore)
    setCriteriaDropdown(criterialStore.criterialListRespone.data)
  }

  // DROPDOWN danh sách Chủ đầu tư 20.2
  const getDropdownInvestor = async (key = '') => {
    await commonPresenter.getCommonDataByKey(commonStore, "ListForeignInvestors");
    if (commonStore.commonRespone.isSuccess) {
      setListInvestor(commonStore.commonRespone.data)
    }
  }
  const debounceSearchInvestor = useDebounce(getDropdownInvestor, 300);

  // DROPDOWN danh sách nhóm hàng mua nhiều
  const getDropdownBestSellerOrder = async (key?: string) => {
    await commonPresenter.getListOrderSeller(commonStore, key)
    if (commonStore.nhomHangMuaNhieu.isSuccess) {
      setListOrderSeller(commonStore.nhomHangMuaNhieu.data)
    }
  }
  const debounceSearchOrderSeller = useDebounce(getDropdownBestSellerOrder, 300);


  // ================================================================= * ----------------------------------------------------------------
  // CHỈNH LẠI DATA ĐỂ CREATE
  const handleFormValuesChange = () => {
    const formData = form.getFieldsValue();
    const listKeys = Object.keys(formData);

    let valuesChange: DetailCriterialIds[] = [];
    // Loại bỏ những field bị emply hoặc undefined
    const dataFilterd = Object.fromEntries(Object.entries(formData).filter(([_, value]) => {
      // kiểm tra xem value có là mảng không, nếu là mảng thì phải kiểm tra xem giá trị
      // nếu = 0 thì vẫn cho phép còn lại thì return false
      if (Array.isArray(value)) {
        if (value[0] || value[1]) {
          return true
        }
        else if (value[0] === 0 || value[1] === 0) {
          return true
        }
        else return false
      } else if (value) {
        return true
      }
      else return false
    }))



    valuesChange = Object.entries(dataFilterd).map((item: any) => {
      return {
        criteriaCode: item[0],
        values: Array.isArray(item[1]) ? item[1].map((i, index) => {
          return {
            criteriaValue: i === null || i === undefined ? null : typeof i === 'object' ? dayjs(i).format('YYYY-MM-DD') : '' + i,
            dataType: i === null || i === undefined ? 'null' : typeof i === 'object' ? 'fromTo' : typeof i,
            sortType: index === 0 ? 'from' : 'to'
          }
        }) : [
          {
            criteriaValue: '' + item[1],
            dataType: typeof item[1]
          }
        ],
        inputType: typeof item[1] === 'object' ? "fromTo" : "single",
      }
    })

    if (onCriterialChange) {
      onCriterialChange(valuesChange);
    }
  };

  useEffect(() => {
    if (listFilter.length)
      handleFormValuesChange();
  }, [listFilter])



  // Kiểm tra validate form trong validation
  useEffect(() => {
    if (isValidated) {
      form.validateFields().then((value) => {
        validation && validation(true)
      }).catch(() => { validation && validation(false) })
    }
  }, [isValidated])



  const handleCheckCallAPI = (code: string) => {
    const checkList = props.dataDetail?.criterias.find(item => item.criteriaCode.includes(code))
    console.log({ checkList });

    return checkList ? true : false
  }

  // =========================== CALL API ĐỂ LẤY DATA ĐỔ VÀO DROPDOWN =====================================
  useEffect(() => {
    // getListFilter();
    // if (handleCheckCallAPI('TC20')) {
    //   debounceSearchInvestor();
    // }
    getDropdownCriteria();
    getDataIndicationsUserMaterial();


    getDataCompanySaleOrg();
  }, []);



  // ------------------------------------- VỊ TRÍ ĐỊA LÍ ------------------------------------

  useEffect(() => {
    if (valuesNation) {
      getDataSaleOffice();
    }
  }, [valuesNation])


  // SET INITIAL VALUES CHO FORM KHI TẠO MỚI SEGMENT PHÂN KHÚC  ===========================================
  useEffect(() => {
    (() => {
      if (listCompanySaleOrg.length && !tabId) {
        form.setFieldValue('TC01.1', listCompanySaleOrg[0].key)
        form.setFieldValue('TC02.1', listCompanySaleOrg[0].key)
        form.setFieldValue('TC03.1', listCompanySaleOrg[0].key)
      }
    })()
  }, [listCompanySaleOrg])



  // ============================================ EDIT DETAIL =============================================
  const handleGetDetail = async () => {
    let keyDetail: string[] = []
    const dataDetail = props.dataDetail?.criterias.map(item => {
      keyDetail.push(item.criteriaCode)
      // value chỉ có 1 giá trị
      if (item.values.length === 1) {
        return {
          [item.criteriaCode]: item.values[0].criteriaValue
        }
      }
      // value có nhiều hơn 1 giá trị
      else {
        // nếu key Code là 1 trong số những mã dưới đây thì sẽ phải format lại theo định dạng ngày tháng
        if (item.criteriaCode === 'TC17.3' ||
          item.criteriaCode === 'TC27.5' ||
          item.criteriaCode === 'TC31.1' ||
          item.criteriaCode === 'TC32.1' ||
          item.criteriaCode === 'TC33.1' ||
          item.criteriaCode === 'TC34.1' ||
          item.criteriaCode === 'TC35.2' ||
          item.criteriaCode === 'TC36.1' ||
          item.criteriaCode === 'TC38.2' ||
          item.criteriaCode === 'TC55.2' ||
          item.criteriaCode === 'TC57.2' ||
          item.criteriaCode === 'TC58.1' ||
          item.criteriaCode === 'TC28.3' ||
          item.criteriaCode === 'TC30.3'
        ) {
          return { [item.criteriaCode]: [item.values[0].criteriaValue ? dayjs(item.values[0].criteriaValue) : undefined, item.values[1].criteriaValue ? dayjs(item.values[1].criteriaValue) : undefined] }
        }
        // value không là những code trên và có length bằng 2
        else if (item.values.length === 2) {
          return {
            [item.criteriaCode]: [item.values[0].criteriaValue, item.values[1].criteriaValue]
          }
        }
        // nếu length value lớn hơn 2
        else {
          return {
            [item.criteriaCode]: item.values.map((item: any) => (item.criteriaValue))
          }
        }
      }
    })

    setListFilter(keyDetail)
    // Convert the array to a single JSON object
    let jsonObject = Object.assign({}, ...dataDetail ?? []);
    form.setFieldsValue(jsonObject)
  }


  useEffect(() => {
    // phải kiểm tra xem trên url cái onchangeTab là false thì call lại detail, nhưng nếu là true thì không call lại detail

    // nên là create sẽ phải không đc call hàm handleGetDetail() để không reset lại field form
    if (!fistRender) {
      if (tabId && criteriaDropdown) {
        handleGetDetail()
        setFistRender(true)
      }
      if (tabIdIsCreate) {
        setFistRender(true)
      }

    }
  }, [tabId, criteriaDropdown, fistRender])




  // ======================== SET INITIAL VALUE FORM KHI QUICK SEARCH ================================
  useEffect(() => {
    if (quickSearch) {
      (() => {
        let keyDetail: string[] = []
        const dataDetail = quickSearch.map(item => {
          keyDetail.push(item.criteriaCode!)

          if (item.value2s.length === 1) {
            return { [item.criteriaCode]: item.value2s[0] }
          } else {
            // kiểm tra nếu criteriaCode là những field này thì format
            if (item.criteriaCode === 'TC17.3' ||
              item.criteriaCode === 'TC27.5' ||
              item.criteriaCode === 'TC31.1' ||
              item.criteriaCode === 'TC32.1' ||
              item.criteriaCode === 'TC33.1' ||
              item.criteriaCode === 'TC34.1' ||
              item.criteriaCode === 'TC35.2' ||
              item.criteriaCode === 'TC36.1' ||
              item.criteriaCode === 'TC38.2' ||
              item.criteriaCode === 'TC55.2' ||
              item.criteriaCode === 'TC57.2' ||
              item.criteriaCode === 'TC58.1' ||
              item.criteriaCode === 'TC28.3' ||
              item.criteriaCode === 'TC30.3'
            ) {
              return {
                [item.criteriaCode]: [item.value2s[0] ? dayjs(item.value2s[0]) : undefined, item.value2s[1] ? dayjs(item.value2s[1]) : undefined]
              }
            } else {
              return {
                [item.criteriaCode]: [item.value2s[0], item.value2s[1]]
              }
            }
          }
        })

        // =================================================================
        setListFilter(keyDetail)
        // Convert the array to a single JSON object
        let jsonObject = Object.assign({}, ...dataDetail ?? []);
        form.setFieldsValue(jsonObject)


      })()
    }
  }, [quickSearch])


  //=======================XXX========================XXX=========================XXX========================= //

  return (
    <Spin spinning={props.loadingSegment}>
      <SearchForm
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
        labelAlign="right"
        form={form}
        column="col-3"
        colon={false}
        onValuesChange={(changedValues, values) => {
          handleFormValuesChange();
        }}

        initialValues={tabId ? undefined : { 'TC35.2.Ex': 'CK' }}
      >

        {/* ------------------------------------ TIÊU CHÍ ---------------------------------------- */}
        <div className="col-span-3 mt-3">
          <span className="text-base font-semibold uppercase">
            {t("segment.tieu-chi")}
          </span>
          <SearchItem
            // name={'segmentTree'}
            label={''} wrapperCol={{ span: 24 }}>
            <TreeSelect
              disabled={tabId}

              placeholder={t('segment.chon-tieu-chi') + '...'}
              // treeData={treeData}
              treeData={criteriaDropdown}
              treeCheckable
              value={listFilter}
              // treeLine
              showCheckedStrategy="SHOW_PARENT"
              // treeNodeFilterProp="label"
              filterTreeNode={(search, item) => {
                return (item.title + "").toLowerCase().includes((search + "").toLowerCase());
              }}
              showSearch
              style={{ width: "100% !important" }}
              allowClear
              onChange={(values, option, extra) => {
                setListFilter(values)
                // Hiển thị title cho từng phân khúc tiêu chí
                const newArr = new Set(extra.allCheckedNodes.map(item => item.node.props.parentTitle))
                setListParrentTitle(Array.from(newArr))

                // TC55 đặc biệt =================================
                const tempt = cloneDeep(values)
                if (tempt.includes('TC55.1')) {
                  const index = tempt.findIndex(item => item === 'TC55.1')
                  tempt.splice(index, 1, 'TC55')
                  setListFilter(tempt)
                } else if (tempt.includes('TC55.2')) {
                  const index = tempt.findIndex(item => item === 'TC55.2')
                  tempt.splice(index, 1, 'TC55')
                  setListFilter(tempt)
                }


                // VỊ TRÍ ĐỊA LÝ (tự động ăn theo)
                if (values.includes('TC26')) {
                  tempt.push('TC21', 'TC22', 'TC23', 'TC24', 'TC25')
                  const tempt2 = uniq(tempt)
                  setListFilter(tempt2)
                } else if (values.includes('TC25')) {
                  tempt.push('TC21', 'TC22', 'TC23', 'TC24')
                  const tempt2 = uniq(tempt)
                  setListFilter(tempt2)
                } else if (values.includes('TC24')) {
                  tempt.push('TC21', 'TC22', 'TC23')
                  const tempt2 = uniq(tempt)
                  setListFilter(tempt2)
                } else if (values.includes('TC23')) {
                  tempt.push('TC21', 'TC22')
                  const tempt2 = uniq(tempt)
                  setListFilter(tempt2)
                }



                // RESET FIELD TRỪ 1 SỐ FIELD CỤ THỂ DƯỚi
                const list = ['TC01', 'TC01.1', 'TC02', 'TC02.1', 'TC03', 'TC03.1', 'TC21', 'TC22']
                const cloneValues = cloneDeep(values);
                const reset = cloneValues.pop();

                if (reset && !list?.includes(reset)) {
                  form.resetFields([reset])
                }
              }
              }
            // maxTagCount={"responsive"}
            />
          </SearchItem>
        </div>
        <div className="col-span-3 grid grid-cols-12">
          <div className={`${tabId ? 'cursor-none pointer-events-none' : ''} col-span-12 lg:col-span-11 col-start-1 flex flex-col lg:grid lg:grid-cols-2 gap-x-default sm:gap-y-2`}>
            <div className="hidden">
              {listFilter.includes("ProfileCode") && (
                /* Mã */
                <SearchItem name={"ProfileCode"} label={t("search-form.code")}>
                  <Input />
                </SearchItem>
              )}
              {listFilter.includes("ProfileForeignCode") && (
                // Mã SAP
                <SearchItem
                  name={"ProfileForeignCode"}
                  label={t("search-form.sap-code")}
                >
                  <Input />
                </SearchItem>
              )}
              {listFilter.includes("ProfileName") && (
                // Tên
                <SearchItem name={"ProfileName"} label={t("search-form.name")}>
                  <Input />
                </SearchItem>
              )}
              {listFilter.includes("Phone") && (
                // SDT liên hệ
                <SearchItem name={"Phone"} label={t("search-form.phone-contact")}>
                  <Input />
                </SearchItem>
              )}
              {listFilter.includes("IsTopInvestor") && (
                // Top chủ đầu tư
                <SearchItem
                  name={"IsTopInvestor"}
                  label={t("search-form.top-investor")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("IsInvestor") && (
                // Là chủ đầu tư
                <SearchItem
                  name={"IsInvestor"}
                  label={t("search-form.is-investor")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("IsDesigner") && (
                // Là thiêt kế
                <SearchItem
                  name={"IsDesigner"}
                  label={t("search-form.is-designer")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("IsContractor") && (
                // Là tổng thầu
                <SearchItem
                  name={"IsContractor"}
                  label={t("search-form.is-contractor")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("CustomerSourceCode") && (
                // Nguồn khách hàng
                <SearchItem
                  name={"CustomerSourceCode"}
                  label={t("search-form.customer-source")}
                >
                  <CustomSelect
                    allowClear
                    options={listCustomerSource}
                    fieldNames={{ label: "value", value: "key" }}
                  />
                </SearchItem>
              )}
              {listFilter.includes("CompanyCode") && (
                // Công ty
                <SearchItem name={"CompanyCode"} label={t("search-form.company")}>
                  <CustomSelect
                    allowClear
                    options={listCompany}
                    fieldNames={{ label: "value", value: "key" }}
                  />
                </SearchItem>
              )}
              {listFilter.includes("StoreId") && (
                // Chi nhánh
                <SearchItem name={"StoreId"} label={t("search-form.branch")}>
                  <CustomSelect
                    options={listStore}
                    selectAll
                    mode="multiple"
                    allowClear
                    fieldNames={{ label: "value", value: "key" }}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </SearchItem>
              )}
              {listFilter.includes("CustomerAccountGroupCode") && (
                // Phân nhóm khách hàng
                <SearchItem
                  name={"CustomerAccountGroupCode"}
                  label={t("search-form.customer-account-group")}
                >
                  <CustomSelect
                    options={listCustomerAccountGroup}
                    mode="multiple"
                    allowClear
                    fieldNames={{ label: "value", value: "key" }}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </SearchItem>
              )}</div>
            {/* ================================================================================================================================== */}
            {/* -----------------------------------------------------QUY MÔ HOẠT ĐỘNG--------------------------------------------------------------*/}
            {/* ================================================================================================================================== */}
            <>
              {((listFilter.includes("Quy mô hoạt động") || listParrentTitle.includes("Quy mô hoạt động")) && (
                <div className='uppercase font-semibold text-default col-span-2 text-center'>Quy mô hoạt động</div>
              ))}
              {/* // Công ty TC01.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC01.1") || listFilter.includes("TC01")) && (
                <SearchItem
                  // name={"TC01.1"}
                  label={"TC01.1 - Công ty (*)"}
                >
                  {/* <CustomSelect
                    options={listCompanySaleOrg}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    onChange={(value, option) => {
                      if (!Array.isArray(option)) {
                        form.setFieldValue('TC02.1', value ? option.key : undefined)
                        form.setFieldValue('TC03.1', value ? option.key : undefined)
                      }
                    }}
                    allowClear
                    showSearch
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC01.1"}
                    fieldProps={{
                      onChange: (value, option) => {
                        if (!Array.isArray(option)) {
                          form.setFieldValue('TC02.1', value ? option.key : undefined)
                          form.setFieldValue('TC03.1', value ? option.key : undefined)
                        }
                      },
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getListSaleOrg(commonStore, 'SEGMENT');
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {/* // Phân loại KH  (Phân loại khách hàng) TC01.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC01.2") || listFilter.includes("TC01")) && (
                // Phân loại KH
                <SearchItem
                  // name={"TC01.2"}
                  label={"TC01.2 - " + t("search-form.customer-type")}
                >
                  {/* <CustomSelect
                    allowClear
                    options={listCustomerType}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "value", value: "key" }}
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC01.2"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerType");
                      return commonStore.commonRespone.data || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC01") || listFilter.includes("TC01.1") || listFilter.includes("TC01.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* // Công ty TC02.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC02.1") || listFilter.includes("TC02")) && (
                <SearchItem
                  start
                  // name={"TC02.1"}
                  label={"TC02.1 - Công ty"}
                >
                  {/* <CustomSelect
                    disabled={(listFilter.includes("TC01") || listFilter.includes("TC01.1")) || form.getFieldValue('TC01.1')}
                    options={listCompanySaleOrg}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                    showSearch
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    disabled={(listFilter.includes("TC01") || listFilter.includes("TC01.1")) || form.getFieldValue('TC01.1')}
                    name={"TC02.1"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getListSaleOrg(commonStore, 'SEGMENT');
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {/* // Ngành nghề TC02.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC02.2") || listFilter.includes("TC02")) && (
                // Ngành nghề
                <SearchItem
                  label={'TC02.2 - ' + t("search-form.career")}>
                  <ProFormSelect
                    showSearch
                    // kiểm tra nếu TC01.2 Phân loại khách hàng đang được pick value là tiêu dùng thì disable
                    disabled={valuesCustomerType === 'C' ? true : false}
                    allowClear
                    name={"TC02.2"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerCareer");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />

                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC02") || listFilter.includes("TC02.1") || listFilter.includes("TC02.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* // Công ty TC03.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC03.1") || listFilter.includes("TC03.2") || listFilter.includes("TC03") || listFilter.includes(t('segment.option-finance')) || listParrentTitle.includes(t('segment.option-finance'))) && (
                <SearchItem
                  start
                  name={"TC03.1"}
                  label={"TC03.1 - Công ty"}>
                  <ProFormSelect
                    showSearch
                    allowClear
                    disabled={(listFilter.includes("TC01") || listFilter.includes("TC01.1")) || !!form.getFieldValue('TC01.1')}
                    name={"TC02.1"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getListSaleOrg(commonStore, 'SEGMENT');
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {/* // Nhóm khách hàng TC03.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC03.2") || listFilter.includes("TC03")) && (
                <SearchItem
                  label={"TC03.2 - Nhóm khách hàng"}
                >
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC03.2"}
                    mode='multiple'
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerGroup");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {/* // Phòng ban NV Kinh doanh TC03.3 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC03.3") || listFilter.includes("TC03")) && (
                <SearchItem
                  label={"TC03.3 - Phòng ban NV Kinh Doanh"}
                >
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC03.3"}
                    mode='multiple'
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getListDepartment(commonStore, undefined, getPlantCode());
                      return (commonStore.commonRespone.data) || [];
                    }
                    }
                  />
                </SearchItem>
              )}

              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC03") || listFilter.includes("TC03.1") || listFilter.includes("TC03.2") || listFilter.includes("TC03.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Thị trường của khách hàng TC04 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC04")) && (
                <SearchItem
                  start
                  // name={"TC04"}
                  label={'TC04 - ' + t("search-form.customer-market")}
                >
                  {/* <CustomSelect
                    fieldNames={{ label: "value", value: "key" }}
                    showSearch
                    allowClear
                    options={customerMarket}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC04"}
                    mode='multiple'
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerMarket");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC04")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Hệ thống showroom TC05 -> Số lượng Showroom */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC05")) && (
                <SearchItem
                  start
                  label={'TC05 - ' + t("search-form.showrooms-qty")}
                >
                  <Space.Compact>
                    <SearchItem name={['TC05', 0]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC05', 1]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC05")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Diện tích showroom TC06 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC06")) && (
                <SearchItem
                  start
                  // name={"TC06"}
                  label={'TC06 - ' + t("search-form.showroom-area")}
                >
                  {/* <CustomSelect
                    mode='multiple'
                    options={showroomArea}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={'TC06'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "Area");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC06")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Xưởng sản xuất (Đếm số lượng) TC07 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC07")) && (
                <SearchItem start
                  label={'TC07 - ' + t("search-form.factory")}
                >
                  <Space.Compact>
                    <SearchItem name={['TC07', 0]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC07', 1]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC07")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/*Diện tích Xưởng sản xuất TC08 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC08")) && (
                <SearchItem start
                  // name={"TC08"}
                  label={'TC08 - Diện tích xưởng SX'}
                >
                  {/* <CustomSelect
                    options={showroomArea}
                    mode='multiple'
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={'TC08'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "Area");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC08")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Văn phòng (Đếm số lượng) TC09 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC09")) && (
                <SearchItem start
                  label={'TC09 - ' + t("search-form.office")}
                >
                  <Space.Compact>
                    <SearchItem name={['TC09', 0]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC09', 1]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC09")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Diện tích văn phòng TC10 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC10")) && (
                <SearchItem start
                  // name={"TC10"}
                  label={'TC10 - ' + t("search-form.office-area")}
                >
                  {/* <CustomSelect
                    options={showroomArea}
                    mode='multiple'
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={'TC10'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "Area");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC10")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Điểm trưng bày (Có hay không, giá trị trưng bày) TC11.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC11.1") || listFilter.includes("TC11")) && (
                <SearchItem
                  start
                  name={"TC11.1"}
                  label={'TC11.1 - ' + t("search-form.display-point")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {/* Giá trị DTB TC11.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC11.2") || listFilter.includes("TC11")) && (
                <SearchItem label='TC11.2 - Giá trị ĐTB'>
                  <Space.Compact>
                    <SearchItem name={['TC11.2', 0]} noStyle >
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VNĐ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC11.2', 1]} noStyle >
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến (VNĐ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC11") || listFilter.includes("TC11.1") || listFilter.includes("TC11.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC11.2") || listFilter.includes("TC11")) && (
              <SearchItem label={'TC11.2 - Giá trị DTB'} name={'TC11.2'} >
                <ProFormDigitRange
                  name="TC11.2"
                  separator="~"
                  fieldProps={{
                    formatter(value, info) {
                      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    },
                  }}
                  placeholder={['Từ', 'Đến']}
                  separatorWidth={40}
                />
              </SearchItem>
            )} */}
              {/* Thị phần / Marketshare TC12 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC12")) && (
                <SearchItem start
                  // name={"TC12"}
                  label={'TC12 - Marketshare'}
                >
                  {/* <CustomSelect
                    options={listMarketShare}
                    fieldNames={{ label: "value", value: "key" }}
                    mode='multiple'
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={"TC12"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "Marketshare");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC12")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Số lượng nhân viên của công ty (Số lượng nhân sự của công ty) TC13 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC13")) && (
                <SearchItem start
                  // name={"TC13"}
                  label={'TC13 - Số lượng nhân sự của công ty'}
                >
                  {/* <CustomSelect
                    options={numberOfEmployees}
                    mode='multiple'
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC13"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "NumberOfEmployees");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC13")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Số lượng nhân viên thiết kế TC14 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC14")) && (
                <SearchItem start
                  // name={"TC14"}
                  label={'TC14 - ' + t("search-form.designer-qty")}
                >
                  {/* <CustomSelect
                    options={numberOfDesigner}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={'TC14'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "NumberOfDesigners");
                      return (commonStore.commonRespone.data);
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC14")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Số lượng bảng hiệu TC15 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC15")) && (
                <SearchItem start label='TC15 - Số lượng bảng hiệu'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC15', 0]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC15', 1]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC15")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* nhóm sản phẩm chủ lực TC16 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC16")) && (
                <SearchItem start
                  // name={"TC16"}
                  label={'TC16 - ' + t("search-form.main-product")}
                >
                  {/* <CustomSelect
                    mode='multiple'
                    options={keyProductGroup}
                    allowClear
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={"TC16"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "KeyProductGroups");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC16")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Tỷ lệ lãi gộp (SAP) TC17 */}
              {/* Tỷ lệ lãi gộp TC17.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC17.1") || listFilter.includes("TC17")) && (
                <SearchItem start label='TC17.1 - Tỷ lệ lãi gộp'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC17.1', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (%)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC17.1', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (%)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top tỷ lệ lãi gộp (max) TC17.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC17.2") || listFilter.includes("TC17")) && (
                <SearchItem
                  name={"TC17.2"}
                  label={"TC17.2 - Top tỷ lệ lãi gộp (Max)"}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
              {/* Thời gian TC17.3 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC17.3") || listFilter.includes("TC17")) && (
                <SearchItem
                  name={"TC17.3"}
                  label={"TC17.3 - Thời gian"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {/* Tỷ lệ lãi gộp min TC17.4 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC17.4") || listFilter.includes("TC17")) && (
                <SearchItem
                  name={"TC17.4"}
                  label={'TC17.4 - Top tỷ lệ lãi gộp (Min)'}
                >
                  <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC17") || listFilter.includes("TC17.1") || listFilter.includes("TC17.2") || listFilter.includes("TC17.3") || listFilter.includes("TC17.4")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Giá trị An Cường đầu tư TC18 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC18")) && (
                <SearchItem start label='TC18 - Giá trị An Cường đầu tư'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC18', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VND)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC18', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (VND)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC18")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Hệ thống kho bãi NPP/ĐL TC19 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC19")) && (
                <SearchItem
                  start
                  // name={"TC19"}
                  label={'TC19 - Hệ thống kho bãi NPP/ĐL'}
                >
                  {/* <CustomSelect
                    showSearch
                    mode='multiple'
                    options={warehouseSystem}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}
                  <ProFormSelect
                    name={'TC19'}
                    showSearch
                    allowClear
                    mode='multiple'
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "WarehouseSystem");
                      return commonStore.commonRespone.data || []
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC19")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Chủ đầu tư nước ngoài TC20.1 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC20.1") || listFilter.includes("TC20")) && (
                <SearchItem
                  start
                  name={"TC20.1"}
                  label={'TC20.1 - ' + t("search-form.foreign-investors")}
                >
                  <CustomSelect
                    options={dropdownTrueFalse}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {/* Danh sách chủ đầu tư TC20.2 */}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC20.2") || listFilter.includes("TC20")) && (
                <SearchItem
                  // name={"TC20.2"}
                  label={"TC20.2 - Danh sách chủ đầu tư"}
                >
                  {/* <CustomSelect
                    allowClear
                    showSearch
                    mode="multiple"
                    filterOption={false}
                    fieldNames={{ label: "value", value: "key" }}
                    options={listInvestor}
                    onBlur={async () => await debounceSearchInvestor()}
                    onClear={() => debounceSearchInvestor()}
                    onSearch={(value) => {
                      value ? debounceSearchInvestor(value) : debounceSearchInvestor()
                    }}
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode="multiple"
                    name={"TC20.2"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" },
                      onBlur: async () => await debounceSearchInvestor(),
                      onClear: () => debounceSearchInvestor(),
                      onSearch: (value) => {
                        value ? debounceSearchInvestor(value) : debounceSearchInvestor()
                      }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "ListForeignInvestors");
                      return (commonStore.commonRespone.data) || []
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes("Quy mô hoạt động") || listFilter.includes("TC20") || listFilter.includes("TC20.1") || listFilter.includes("TC20.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
            </>
            {/* =====================================XX========================================XX================================================= */}
            {/* ================================================================================================================================== */}
            {/* ---------------------------------------------------------KHU VỰC-------------------------------------------------------------------*/}
            {/* ======================================================= VỊ TRÍ ĐỊA LÍ ============================================================ */}
            <>
              {((listFilter.includes(t('segment.option-location')) || listParrentTitle.includes(t('segment.option-location'))) && (
                <div className='uppercase font-semibold text-default col-span-2 text-center'>Vị trí địa lí</div>
              ))}

              {/* Khu vực TC20.5 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC20.5")) && (
                // Khu vực
                <SearchItem start
                  name={"TC20.5"}
                  label={'TC20.5 - ' + t("search-form.market")}
                >
                  <CustomSelect
                    options={[{
                      label: 'Trong nước',
                      value: 'TN',
                    },
                    {
                      label: 'Ngoài nước',
                      value: 'NN',
                    }
                    ]}
                    onChange={async (value, option) => {
                      if (value === 'TN') {
                        form.setFieldValue('TC22', 'VN')
                      } else {
                        form.resetFields(['TC22'])
                      }
                      form.resetFields(['TC23', 'TC24', 'TC25', 'TC26', 'TC21'])

                    }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC20.5")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}

              {/* Châu lục /continents TC21 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC21")) && (
                <SearchItem
                  label={'TC21 - ' + t("search-form.continents")}
                  start
                >
                  <ProFormSelect
                    showSearch
                    allowClear
                    disabled={thiTruong === 'TN'}
                    name={"TC21"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" },
                      onChange: async (value, option) => {
                        // await getDataContries(option?.keys)
                        form.resetFields(['TC22', 'TC23', 'TC24', 'TC25', 'TC26'])
                      },
                    }}
                    request={async () => {
                      // set initial value cho châu lục là CHÂU Á
                      await commonPresenter.getCommonDataByKey(commonStore, "Continents");
                      if (commonStore.commonRespone.isSuccess) {
                        // if (!tabId) {
                        //   form.setFieldValue('TC21', '2101')
                        // }
                        return commonStore.commonRespone.data || [];
                      } else {
                        return []
                      }
                    }
                    } />

                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC21")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Quốc gia / countries TC22 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC22")) && (
                <SearchItem start
                  // name={"TC22"}
                  label={'TC22 - ' + t("search-form.country")}
                >
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC22"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" },
                      onChange: async (value, option) => {
                        form.setFieldValue('TC23', undefined)
                        if (!value) {
                          setListSaleOffice([])
                        }
                        form.resetFields(['TC23', 'TC24', 'TC25', 'TC26'])
                      },
                    }}
                    request={async () => {
                      const continent = form.getFieldValue('TC21') || '2101'
                      await commonPresenter.getCommonDataByKey(commonStore, "Nation", continent);
                      if (commonStore.commonRespone.isSuccess) {
                        // set initial value cho quốc gia là việt nam
                        // if (!tabId) {
                        //   form.setFieldValue('TC22', 'VN')
                        // }
                        return (commonStore.commonRespone.data) || [];
                      } else {
                        return []
                      }

                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC22")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Khu vực TC23 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC23")) && (
                // Khu vực
                <SearchItem start
                  name={"TC23"}
                  label={'TC23 - ' + t("search-form.area")}
                >
                  <CustomSelect
                    options={listSaleOffice}
                    onChange={async (value, option) => {
                      await getDataProvince(option?.key);
                      form.resetFields(['TC24', 'TC25', 'TC26'])
                    }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "value", value: "key" }}
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC23")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Tỉnh/Thành phố TC24 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC24")) && (
                <SearchItem start name={"TC24"} label={'TC24 - ' + t("search-form.province")}>
                  <CustomSelect
                    mode="multiple"
                    options={listProvince}
                    onChange={async (value, option) => {
                      if (option.length) {
                        await getDataDistrict(option.map((i: any) => i.key));
                      } else {
                        setListDistrict([]);
                      }
                    }}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC24")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* // Quận/Huyện TC25 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC25")) && (
                <SearchItem start
                  name={"TC25"}
                  label={'TC25 - ' + t("search-form.district")}
                >
                  <CustomSelect
                    mode="multiple"
                    options={listDistrict}
                    onChange={async (value, option) => {
                      if (option.length) {
                        await getDataWard(option.map((i: any) => i.key));
                      } else {
                        setListWard([]);
                      }
                    }}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC25")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* // Phường/xã TC26 */}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC26")) && (
                <SearchItem start name={"TC26"} label={'TC26 - ' + t("search-form.wards")}>
                  <CustomSelect
                    mode="multiple"
                    options={listWard}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-location')) || listFilter.includes("TC26")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
            </>
            {/* ===============================================XX===============================XX================================================ */}
            {/* ================================================================================================================================== */}
            {/* ----------------------------------------------------TÀI CHÍNH KHÁCH HÀNG-----------------------------------------------------------*/}
            {/* ================================================================================================================================== */}
            <>
              {((listFilter.includes(t('segment.option-finance')) || listParrentTitle.includes(t('segment.option-finance'))) && (
                <div className='uppercase font-semibold text-default col-span-2 text-center'>tài chính khách hàng</div>
              ))}
              {/* doanh số TC27 */}
              {/* Số năm mua hàng liên tiếp TC27.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27.1") || listFilter.includes("TC27")) && (
                <SearchItem
                  tooltip={'Tính từ hiện tại trở về trước'}
                  label={'TC27.1 - Số năm mua hàng liên tiếp'}>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC27.1', 0]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC27.1', 1]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Giá trị doanh số TC27.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27.2") || listFilter.includes("TC27")) && (
                <SearchItem label='TC27.2 - Giá trị doanh số'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC27.2', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VNĐ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC27.2', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (VNĐ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top giá trị doanh số(Max) TC27.3 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27.3") || listFilter.includes("TC27")) && (
                <SearchItem
                  name={"TC27.3"}
                  label={'TC27.3 - Top giá trị doanh số(Max)'}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
              {/* Top gía trị doanh số(min) TC27.4 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27.4") || listFilter.includes("TC27")) && (
                <SearchItem
                  name={"TC27.4"}
                  label={'TC27.4 - Top giá trị doanh số(Min)'}
                >
                  <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} className='!w-full' />
                </SearchItem>
              )}
              {/* Thời gian phát sinh doanh số TC27.5 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27.5") || listFilter.includes("TC27")) && (
                <SearchItem
                  name={"TC27.5"}
                  label={'TC27.5 - Thời gian phát sinh doanh số'}
                >
                  {/* <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} className='!w-full' /> */}
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC27") || listFilter.includes("TC27.1") || listFilter.includes("TC27.2") || listFilter.includes("TC27.3") || listFilter.includes("TC27.4") || listFilter.includes("TC27.5")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Công nợ (hạn mức) - SAP TC28 */}
              {/* Giá trị công nợ TC28.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC28.1") || listFilter.includes("TC28")) && (
                <SearchItem start label='TC28.1 - Giá trị công nợ'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC28.1', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VNĐ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC28.1', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (VNĐ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top giá trị công nợ(Max) TC28.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC28.2") || listFilter.includes("TC28")) && (
                <SearchItem
                  name={"TC28.2"}
                  label={'TC28.2 - Top giá trị công nợ(Max)'}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
              {/* thời gian công nợ(hạn mức) - SAP */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC28.3") || listFilter.includes("TC28")) && (
                <SearchItem
                  name={"TC28.3"}
                  label={'TC28.3 - Thời gian công nợ(hạn mức) - SAP'}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC28") || listFilter.includes("TC28.1") || listFilter.includes("TC28.2") || listFilter.includes("TC28.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Công nợ (Thời hạn thanh toán)-SAP TC29 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC29")) && (
                <SearchItem start
                  //  name={'TC29'}
                  label='TC29 - Thời hạn thanh toán'>
                  {/* <CustomSelect
                    options={timePayment}
                    allowClear
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    name={'TC29'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "PaymentTerm");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC29")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Công nợ (Thời gian trung bình quá hạn)-SAP TC30.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC30") || listFilter.includes("TC30.1")) && (
                <SearchItem start
                  label='TC30.1 - Thời hạn trung bình quá hạn'>
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={'TC30.1'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "THANHTOANQUAHAN");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {/* Nhập top nợ xấu TC30.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC30") || listFilter.includes("TC30.2")) && (
                <SearchItem name={'TC30.2'} label='TC30.2 - Top nợ xấu'>
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}

              {/* Thời gian công nợ TC30.3 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC30") || listFilter.includes("TC30.3")) && (
                <SearchItem name={'TC30.3'} label='TC30.3 - Thời gian công nợ'>
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC30") || listFilter.includes("TC30.1") || listFilter.includes("TC30.2") || listFilter.includes("TC30.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Doanh số mua hàng gián tiếp TC31 */}
              {/* Thời gian phát sinh doanh số gián tiếp TC31.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC31.1") || listFilter.includes("TC31")) && (
                <SearchItem
                  start
                  name={"TC31.1"}
                  label={"TC31.1 - Thời gian phát sinh doanh số gián tiếp"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'MM/YYYY'} picker='month' className='!w-full' />
                </SearchItem>
              )}
              {/* Giá trị doanh số TC31.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC31.2") || listFilter.includes("TC31")) && (
                <SearchItem label={'TC31.2 - ' + t('search-form.value-revenue')}>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC31.2', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VNĐ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC31.2', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (VNĐ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top giá trị doanh số (Max) TC31.3 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC31.3") || listFilter.includes("TC31")) && (
                <SearchItem
                  name={"TC31.3"}
                  label={"TC31.3 - Top giá trị doanh số gián tiếp (Max)"}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC31") || listFilter.includes("TC31.1") || listFilter.includes("TC31.2") || listFilter.includes("TC31.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Doanh số công ty mẹ TC32 */}
              {/* Thời gian phát sinh doanh số theo cty mẹ TC32.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC32.1") || listFilter.includes("TC32")) && (
                <SearchItem
                  start
                  name={"TC32.1"}
                  label={"TC32.1 - Thời gian phát sinh doanh số theo công ty mẹ"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'MM/YYYY'} picker='month' className='!w-full' />
                </SearchItem>
              )}
              {/* Giá trị doanh số theo cty mẹ TC32.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC32.2") || listFilter.includes("TC32")) && (
                <SearchItem label='TC32.2 - Giá trị doanh số theo công ty mẹ'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC32.2', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC32.2', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top giá trị doanh số theo cty mẹ (Max) TC32.3 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC32.3") || listFilter.includes("TC32")) && (
                <SearchItem
                  name={"TC32.3"}
                  label={"TC32.3 - Top giá trị doanh số theo công ty mẹ (Max)"}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC32") || listFilter.includes("TC32.1") || listFilter.includes("TC32.2") || listFilter.includes("TC32.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Doanh thu trung bình trên một đơn hàng TC33  */}
              {/* Thời gian doanh thu trung bình TC33.1  */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC33.1") || listFilter.includes("TC33")) && (
                <SearchItem
                  start
                  name={"TC33.1"}
                  label={" TC33.1 - Thời gian doanh thu trung bình"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'MM/YYYY'} picker='month' className='!w-full' />
                </SearchItem>
              )}
              {/* Giá trị doanh thu trung bình TC33.2  */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC33.2") || listFilter.includes("TC33")) && (
                <SearchItem label='TC33.2 - Giá trị doanh thu trung bình'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC33.2', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (VNĐ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC33.2', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (VNĐ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC33") || listFilter.includes("TC33.1") || listFilter.includes("TC33.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Doanh thu luỹ kế TC34 */}
              {/* Thời gian doanh thu luỹ kế TC34.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC34.1") || listFilter.includes("TC34")) && (
                <SearchItem
                  start
                  name={"TC34.1"}
                  // rules={[{ required: listFilter.includes("TC34.1") || listFilter.includes("TC34"), message: 'Hãy nhập thông tin' }]}
                  label={"TC34.1 - Thời gian doanh thu lũy kế"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'MM/YYYY'} picker='month' className='!w-full' />
                </SearchItem>
              )}
              {/* Tỷ lệ doanh thu luỹ kế TC34.3 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC34.3") || listFilter.includes("TC34")) && (
                <SearchItem label='TC34.3 - Tỷ lệ doanh thu lũy kế'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC34.3") || listFilter.includes("TC34"), message: 'Hãy nhập thông tin' }]}
                      name={['TC34.3', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (%)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC34.3") || listFilter.includes("TC34"), message: 'Hãy nhập thông tin' }]}
                      name={['TC34.3', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (%)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC34") || listFilter.includes("TC34.1") || listFilter.includes("TC34.3")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Tăng trưởng doanh số (theo năm) TC35.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC35.1") || listFilter.includes("TC35.2") || listFilter.includes("TC35")) && (
                <SearchItem
                  label='TC35.1 - Tỷ lệ tăng trưởng'
                >
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC35.1") || listFilter.includes("TC35"), message: 'Hãy nhập thông tin' }]}
                      name={['TC35.1', 0]} noStyle>
                      <InputNumber
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (%)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC35.1") || listFilter.includes("TC35"), message: 'Hãy nhập thông tin' }]}
                      name={['TC35.1', 1]} noStyle>
                      <InputNumber
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (%)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Thời gian TC35.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC35.1") || listFilter.includes("TC35.2") || listFilter.includes("TC35")) && (
                <div className='flex flex-col gap-2'>
                  <SearchItem
                    name={"TC35.2"}
                    // rules={[{ required: listFilter.includes("TC35.2") || listFilter.includes("TC35"), message: 'Hãy nhập thông tin' }]}
                    label={"TC35.2 - Thời gian"}
                  >
                    <RangePicker allowEmpty={[true, true]} format={'MM/YYYY'} picker='month' className='!w-full' />
                  </SearchItem>
                  <SearchItem
                    name={"TC35.2.Ex"}
                    // rules={[{ required: listFilter.includes("TC35.2") || listFilter.includes("TC35"), message: 'Hãy nhập thông tin' }]}
                    label={" "}
                    colon={false}
                  >
                    <CustomSelect options={[
                      { value: 'CK', label: 'Cùng kỳ' },
                      { value: 'KT', label: 'Kỳ trước' }
                    ]} />
                  </SearchItem>
                </div>
              )}

              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC35") || listFilter.includes("TC35.1") || listFilter.includes("TC35.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Tăng trưởng Doanh số (CAGR) TC36 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC36")) && (
                <SearchItem
                  label='TC36 - Tăng trưởng doanh số (CAGR)'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC36.1") || listFilter.includes("TC36"), message: 'Hãy nhập thông tin' }]}
                      name={['TC36', 0]} noStyle>
                      <InputNumber
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem
                      // rules={[{ required: listFilter.includes("TC36.1") || listFilter.includes("TC36"), message: 'Hãy nhập thông tin' }]}
                      name={['TC36', 1]} noStyle>
                      <InputNumber
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Thời gian TC36.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC36.1") || listFilter.includes("TC36")) && (
                <SearchItem
                  name={"TC36.1"}
                  // rules={[{ required: listFilter.includes("TC36.1") || listFilter.includes("TC36"), message: 'Hãy nhập thông tin' }]}
                  label={"TC36.1 - Thời gian(CAGR)"}
                >
                  <RangePicker allowEmpty={[true, true]} picker='year' className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC36") || listFilter.includes("TC36.1")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Doanh số Spec TC37 */}
              {/* Giá trị doanh số Spec TC37.1 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC37.1") || listFilter.includes("TC37")) && (
                <SearchItem label='TC37.1 - Giá trị doanh số spec'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC37.1', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ (Tỷ)" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC37.1', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến (Tỷ)"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Top giá trị doanh số (Max) TC37.2 */}
              {(listFilter.includes(t('segment.option-finance')) || listFilter.includes("TC37.2") || listFilter.includes("TC37")) && (
                <SearchItem
                  name={"TC37.2"}
                  label={"TC37.2 - Top giá trị doanh số Spec(Max)"}
                >
                  <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} />
                </SearchItem>
              )}
            </>
            {/* ==================================================XX====================================XX======================================== */}
            {/* ================================================================================================================================== */}
            {/* -----------------------------------------------------THÓI QUEN TIÊU DÙNG-----------------------------------------------------------*/}
            {/* ================================================================================================================================== */}
            <>
              {((listFilter.includes(t("segment.option-habit")) || listParrentTitle.includes(t("segment.option-habit"))) && (
                <div className='uppercase font-semibold text-default col-span-2 text-center'>thói quen tiêu dùng</div>
              ))}
              {/* Khách ghé thăm showroom SR TC38 */}
              {/* Số lượng ghé thăm TC38.1 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC38.1") || listFilter.includes("TC38")) && (
                <SearchItem label='TC38.1 - Số lượng ghé thăm'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC38.1', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC38.1', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Thời gian ghé thăm TC38.2 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC38.2") || listFilter.includes("TC38")) && (
                <SearchItem
                  name={"TC38.2"}
                  label={'TC38.2 - Thời gian ghé thăm'}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC38") || listFilter.includes("TC38.1") || listFilter.includes("TC38.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Loại KH ghé thăm (cũ/mới) TC39 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC39")) && (
                <SearchItem start
                  // name={"TC39"}
                  label={'TC39 - Loại KH ghé thăm'}
                >
                  {/* <CustomSelect
                    options={listTypeVisitCustomer}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC39"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerClass");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC39")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Thị hiếu KH (Khách ghé thăm) TC40 */}
              {/* Thị hiếu TC40.2 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC40.2") || listFilter.includes("TC40")) && (
                <SearchItem start
                  // name={"TC40.2"}
                  label={'TC40.2 - ' + t("search-form.customer-trend")}
                >
                  {/* <CustomSelect
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                    mode='multiple'
                    options={listTrend}
                    showSearch
                    filterOption={false}
                    onSearch={(values) => values ? debounceSearchSPTH(values) : debounceSearchSPTH()}
                    onClear={() => debounceSearchSPTH()}
                    onBlur={() => debounceSearchSPTH()}
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    mode='multiple'
                    name={"TC40.2"}
                    fieldProps={{
                      filterOption: false,
                      fieldNames: { label: "value", value: "key" },
                      onSearch: (values) => values ? debounceSearchSPTH(values) : debounceSearchSPTH(),
                      onClear: () => debounceSearchSPTH(),
                      onBlur: () => debounceSearchSPTH(),
                    }}
                    request={async () => {
                      await commonPresenter.getListSPTH(commonStore, undefined);
                      return commonStore.commonRespone.data || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC40") || listFilter.includes("TC40.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Nhu cầu làm nội thất TC41 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC41")) && (
                <SearchItem start
                  // name={"TC41"}
                  label={"TC41 - Nhu cầu làm nội thất"}
                >
                  {/* <CustomSelect
                    options={listHouseType}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC41"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "HouseType");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC41")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Hình thức TC42 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC42")) && (
                <SearchItem start
                  // name={"TC42"}
                  label={"TC42 - Hình thức"}
                >
                  {/* <CustomSelect
                    options={listShapeType}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC42"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "ShapeType");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC42")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Chỉ định dùng vật liệu An Cường TC43 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC43")) && (
                <SearchItem start
                  // name={"TC43"}
                  label={"TC43 - Chỉ định dùng vật liệu An Cường"}
                >
                  {/* <CustomSelect
                    options={listIndicationUser}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC43"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "IndicationsUseACMaterial");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC43")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Mức tin dùng sản phẩm AC TC44 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC44")) && (
                <SearchItem start
                  label={"TC44 - Mức tin dùng sản phẩm AC"}
                >
                  <Space.Compact>
                    <SearchItem name={['TC44', 0]} noStyle >
                      <InputNumber min={0} max={10} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC44', 1]} noStyle >
                      <InputNumber min={0} max={10} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC44")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Mức tương tác TC45 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC45")) && (
                <SearchItem start
                  label={'TC45 - ' + t("search-form.level-interaction")}
                >
                  <Space.Compact>
                    <SearchItem name={['TC45', 0]} noStyle >
                      <InputNumber min={0} max={10} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC45', 1]} noStyle >
                      <InputNumber min={0} max={10} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC45")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Phân khúc đầu tư TC46 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC46")) && (
                <SearchItem start
                  name={"TC46"}
                  label={'TC46 - ' + t("search-form.segment-invest")}
                >
                  <ProFormSelect
                    showSearch name={'TC46'} request={() => getDropdownByKey('InvestmentSegment')} />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC46")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* phân khúc dự án thiết kế TC47 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC47")) && (
                <SearchItem start
                  name={"TC47"}
                  label={'TC47 - ' + t("search-form.pk-duan-tt")}
                >
                  <ProFormSelect showSearch name={'TC47'} request={() => getDropdownByKey('DesignSegment')} />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC47")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Lĩnh vự thiết kế TC48 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC48")) && (
                <SearchItem start
                  name={"TC48"}
                  label={'TC48 - ' + t("search-form.design-field")}
                >
                  <ProFormSelect showSearch name={'TC48'} request={() => getDropdownByKey('DesignMajor')} />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC48")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Tuổi khách hàng TC49 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC49")) && (
                <SearchItem start label='TC49 - Tuổi khách hàng'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC49', 0]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC49', 1]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC49")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Số năm mua hàng TC50 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC50")) && (
                <SearchItem start
                  tooltip="Đếm số năm khách hàng phát sinh doanh thu"
                  label={'TC50 - ' + t("search-form.number-purchase")}
                >
                  <Space.Compact>
                    <SearchItem name={['TC50', 0]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC50', 1]} noStyle >
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC50")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Nguồn KH TC51 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC51")) && (
                // Nguồn khách hàng
                <SearchItem start
                  // name={"TC51"}
                  label={'TC51 - ' + t("search-form.customer-source")}
                >
                  {/* <CustomSelect
                    allowClear
                    mode='multiple'
                    options={listCustomerSource}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch
                    fieldNames={{ label: "value", value: "key" }}
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC51"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerSource");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />

                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC51")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Biết đến SP công ty TC52 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC52")) && (
                <SearchItem start
                  name={"TC52"}
                  label={'TC52 - Biết đến sản phẩm công ty'}
                >
                  <ProFormSelect showSearch
                    mode='multiple'
                    name={'TC52'}
                    request={() => getDropdownByKey('SocialMedia')} />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC52")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Nhóm hàng mua nhiều TC53.1 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC53.1") || listFilter.includes("TC53")) && (
                <SearchItem start
                  name={"TC53.1"}
                  label={'TC53.1 - Nhóm hàng mua nhiều'}
                >
                  {/* <CustomSelect
                    mode='multiple'
                    options={listOrderSeller}
                    onSearch={(value) => {
                      value ? debounceSearchOrderSeller(value) : debounceSearchOrderSeller()
                    }}
                    onClear={() => debounceSearchOrderSeller()}
                    onBlur={() => debounceSearchOrderSeller()}
                    showSearch
                    filterOption={false}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    mode="multiple"
                    name={"TC53.1"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" },
                      onBlur: async () => await debounceSearchOrderSeller(),
                      onClear: () => debounceSearchOrderSeller(),
                      onSearch: (value) => {
                        value ? debounceSearchOrderSeller(value) : debounceSearchOrderSeller()
                      }
                    }}
                    request={async () => {
                      await commonPresenter.getListOrderSeller(commonStore, undefined)
                      return (commonStore.nhomHangMuaNhieu.data) || []
                    }
                    } />
                </SearchItem>
              )}
              {/* Top nhóm hàng TC53.2 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC53.2") || listFilter.includes("TC53")) && (
                <SearchItem
                  name={"TC53.2"}
                  label={'TC53.2 - Top nhóm hàng'}
                >
                  <InputNumber
                    className='!w-full'
                    max={5}
                    min={0}
                  />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC53") || listFilter.includes("TC53.1") || listFilter.includes("TC53.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Thói quen mua sắm TC54 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC54")) && (
                <SearchItem start
                  name={"TC54"}
                  label={'TC54 - ' + t("search-form.shopping-habits")}
                >
                  <ProFormSelect showSearch name={'TC54'} request={() => getDropdownByKey('BuyHabit')} />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC54")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Số đơn hàng trong 1 năm TC55 */}
              {/* Số đơn đặt hàng TC55.1 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC55") || listFilter.includes("TC55.1")) && (
                <SearchItem start label='TC55.1 - Số đơn hàng trong 1 năm'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC55.1', 0]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC55.1', 1]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Thời gian TC55.2 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC55") || listFilter.includes("TC55.2")) && (
                <SearchItem
                  name={"TC55.2"}
                  label={"TC55.2 - Thời gian"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC55") || listFilter.includes("TC55.1") || listFilter.includes("TC55.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Thời gian chưa mua hàng (Tháng) TC56 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC56")) && (
                <SearchItem start label='TC56 - Số tháng chưa mua hàng'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC56', 0]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC56', 1]} noStyle>
                      <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC56")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* % trả hàng TC57.1 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC57.1") || listFilter.includes("TC57")) && (
                <SearchItem start label='TC57.1 - % trả hàng'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem name={['TC57.1', 0]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem name={['TC57.1', 1]} noStyle>
                      <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* Thời gian TC57.2 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC57.2") || listFilter.includes("TC57")) && (
                <SearchItem
                  name={"TC57.2"}
                  label={"TC57.2 - Thời gian"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC57") || listFilter.includes("TC57.1") || listFilter.includes("TC57.2")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* % XLKN TC58 */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC58")) && (
                // <SearchItem
                //   name={"TC58"}
                //   label={"TC58 - % XLKN"}
                // >
                //   <InputNumber formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                //     style={{ width: '100%', textAlign: 'right' }} />
                // </SearchItem>

                <SearchItem
                  label='TC58 - % XLKN'>
                  <Space.Compact block className='w-full [&_.blue]:!flex-auto ' >
                    <SearchItem
                      name={['TC58', 0]} noStyle>
                      <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                    </SearchItem>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: 'none',
                      }}
                      placeholder="~"
                      disabled
                    />
                    <SearchItem
                      name={['TC58', 1]} noStyle>
                      <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                        className="site-input-right"
                        style={{
                          width: "100%",
                          textAlign: 'right',
                        }}
                        placeholder="Đến"
                      />
                    </SearchItem>
                  </Space.Compact>
                </SearchItem>
              )}
              {/* TC58.1 từ năm đến năm */}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC58") || listFilter.includes("TC58.1")) && (
                <SearchItem
                  name={"TC58.1"}
                  label={"TC58.1 - Thời gian"}
                >
                  <RangePicker allowEmpty={[true, true]} format={'DD/MM/YYYY'} className='!w-full' />
                </SearchItem>
              )}
              {(listFilter.includes(t("segment.option-habit")) || listFilter.includes("TC58") || listFilter.includes("TC58.1")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}

            </>
            {/* ==================================================XX====================================XX======================================== */}
            {/* ================================================================================================================================== */}
            {/* -------------------------------------------------------THÔNG TIN CÁ NHÂN-----------------------------------------------------------*/}
            {/* ================================================================================================================================== */}
            <>
              {((listFilter.includes(t('segment.option-info')) || listParrentTitle.includes(t('segment.option-info'))) && (
                <div className='uppercase font-semibold text-default col-span-2 text-center'>thông tin cá nhân</div>
              ))}
              {/* Độ tuổi */}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC59")) && (
                <SearchItem
                  name={"TC59"}
                  label={'TC59 - ' + t("search-form.age")}
                >
                  <ProFormSelect
                    showSearch
                    name={'TC59'}
                    mode='multiple'
                    request={() => getDropdownByKey('Age')} />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC59")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Giới tính */}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC60")) && (
                <SearchItem
                  name={"TC60"}
                  label={'TC60 - ' + t("search-form.sex")}
                >
                  <Radio.Group>
                    <Radio value={'male'}>{t('search-form.male')}</Radio>
                    <Radio value={'female'}>{t('search-form.female')}</Radio>
                    <Radio value={'other'}>{t('search-form.other')}</Radio>
                  </Radio.Group>
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC60")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Quốc tịch*/}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC61")) && (
                <SearchItem
                  // name={"TC61"}
                  label={'TC61 - ' + t("search-form.nationality")}
                >
                  {/* <CustomSelect
                    options={allCountries}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={'TC61'}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "Nation", '2100,2101,2102,2103,2104');
                      return commonStore.commonRespone.data || [];
                    }
                    } />
                </SearchItem>
              )}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC61")) && (
                <Divider className='col-span-2 !my-2 h-[2px] !py-0' plain></Divider>
              )}
              {/* Ngành nghề (khách lẻ)*/}
              {(listFilter.includes(t('segment.option-info')) || listFilter.includes("TC62")) && (
                <SearchItem
                  name={"TC62"}
                  label={'TC62 - ' + t("search-form.career") + ' (KH lẻ)'}
                >
                  {/* <CustomSelect
                    showSearch
                    options={listCustomerCareerRetail}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                  /> */}

                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"TC62"}
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerCareerRetail");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
            </>
            {/* =======================================XX=================================XX========================================= */}
            <div className="hidden">
              {listFilter.includes("CustomerGroupCode") && (
                // Nhóm khách hàng
                <SearchItem
                  // name={"CustomerGroupCode"}
                  label={t("search-form.customer-group")}
                >
                  {/* <CustomSelect
                    mode="multiple"
                    options={listCustomerGroup}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                  /> */}
                  <ProFormSelect
                    showSearch
                    allowClear
                    name={"CustomerGroupCode"}
                    mode='multiple'
                    fieldProps={{
                      fieldNames: { label: "value", value: "key" }
                    }}
                    request={async () => {
                      await commonPresenter.getCommonDataByKey(commonStore, "CustomerGroup");
                      return (commonStore.commonRespone.data) || [];
                    }
                    } />
                </SearchItem>
              )}
              {listFilter.includes("SalesEmployeeCode") && (
                // NV kinh doanh
                <SearchItem
                  name={"SalesEmployeeCode"}
                  label={t("search-form.business-man")}
                  end
                >
                  <CustomSelect
                    options={listSalesEmployee}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={false}
                    onSearch={async (value) => searchSalesEmployee("NVKD", value)}
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("RolesCode") && (
                // Phòng ban
                <SearchItem
                  name={"RolesCode"}
                  label={t("search-form.department")}
                >
                  <CustomSelect
                    options={listDepartment}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={(input, option) =>
                      (option?.value ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                    showSearch
                  />
                </SearchItem>
              )}
              {listFilter.includes("TaxNo") && (
                // Mã số thuế
                <SearchItem name={"TaxNo"} label={t("search-form.tax-no")}>
                  <Input />
                </SearchItem>
              )}
              {listFilter.includes("PhanHang") && (
                // Phân hạng KH
                <SearchItem
                  name={"PhanHang"}
                  label={t("search-form.classification")}
                >
                  <CustomSelect
                    options={listCustomerRank}
                    fieldNames={{ label: "value", value: "key" }}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("AdminEmployee") && (
                // NV Admin
                <SearchItem
                  name={"AdminEmployee"}
                  label={t("search-form.admin-employee")}
                >
                  <CustomSelect
                    options={listAdminEmployee}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={false}
                    onSearch={async (value) => searchSalesEmployee("NVAD", value)}
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("Actived") && (
                // Trạng thái
                <SearchItem
                  name={"Actived"}
                  label={t("zalo-notification.status")}
                >
                  <CustomSelect
                    options={status}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={false}
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("CreateByCode") && (
                // Người tạo
                <SearchItem
                  name={"CreateByCode"}
                  label={t("search-form.created-by")}
                >
                  <CustomSelect
                    options={listCreateBy}
                    fieldNames={{ label: "value", value: "key" }}
                    filterOption={false}
                    onSearch={async (value) =>
                      searchSalesEmployee("CREATE", value)
                    }
                    showSearch
                    allowClear
                  />
                </SearchItem>
              )}
              {listFilter.includes("CreateCommonDate") && (
                <>
                  {/* // Ngày tạo */}
                  <SearchItem
                    name={"CreateCommonDate"}
                    label={t("search-form.created-date")}
                    start
                  >
                    <CustomSelect
                      options={listCommonDate}
                      fieldNames={{ label: "value", value: "key" }}
                      onChange={async (value, option) => {
                        if (option) {
                          setDisabledCreateDate(
                            option.key === "Custom" ? false : true
                          );
                          await getDateByKey(option.key);
                        } else {
                          setDisabledCreateDate(false);
                          form.setFieldValue("CreateFromDate", undefined);
                          form.setFieldValue("CreateToDate", undefined);
                          handleFormValuesChange();
                        }
                      }}
                      allowClear
                    />
                  </SearchItem>
                  {/* // Từ ngày ==> đến ngày */}
                  <SearchItem
                    name={"CreateFromDate"}
                    label={t("search-form.from")}
                    start
                  >
                    <DatePicker
                      disabled={disabledCreateDate}
                      format="DD/MM/YYYY"
                      className="w-full"
                    />
                  </SearchItem>
                  <SearchItem name={"CreateToDate"} label={t("search-form.to")}>
                    <DatePicker
                      disabled={disabledCreateDate}
                      format="DD/MM/YYYY"
                      className="w-full"
                    />
                  </SearchItem>
                </>
              )}
              {listFilter.includes("Email") && (
                // Email
                <SearchItem name={"Email"} label={"Email"}>
                  <Input />
                </SearchItem>
              )}</div>
          </div>
        </div>
      </SearchForm >
    </Spin>
  );
}

export default observer(Criterial);
